module.exports = __webpack_public_path__ + "images/img-Ye18UME.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/quids.jpg
// module id = 2007
// module chunks = 0